export const formInputDefaultProps = {
    style: {},
    className: '',
    validation: {
        state: null,
    },
    saveUnmasked: false,
};
